export const httpServiceHost = {
    production: 'https://api.tokenlon.im',
    staging: 'https://api.imstaging.works',
    development: 'https://api.imdev.works',
};
export const jsonRpcServiceHost = {
    production: 'https://tokenlon-market.tokenlon.im/rpc',
    staging: 'https://tokenlon-market.imstaging.works/rpc',
    development: 'https://tokenlon-market.imdev.works/rpc',
};
export const stakingSubgraphServiceHost = {
    production: 'https://subgraph.tokenlon.im/subgraph/ethereum/tokenlon_staking',
    staging: 'https://subgraph.imstaging.works/subgraph/ethereum/tokenlon_staking',
    development: 'https://api.thegraph.com/subgraphs/name/consenlabs/tokenlon-v5-staking',
};
//# sourceMappingURL=serviceHost.js.map